import { httpResource } from '@angular/common/http';
import { effect, inject, Injectable, signal, untracked } from '@angular/core';

import type { IReportBody } from '@rpgc-ai/shared-interfaces/interfaces/complain.interface';

import { TranslocoService } from '@jsverse/transloco';

import { NotificationsService } from '../notifications/notifications.service';

@Injectable({
  providedIn: 'root',
})
export class ReportCharacterService {
  readonly #notificationsService = inject(NotificationsService);
  readonly #translocoService = inject(TranslocoService);

  readonly reportCharacterRequestBody = signal<IReportBody | null>(null);

  readonly resource = httpResource<{ success: boolean }>(() => {
    const { id, report } = this.reportCharacterRequestBody() ?? {};

    if (!id || !report) {
      return;
    }

    return {
      url: `/characters/${id}/report`,
      method: 'POST',
      body: report,
    };
  });

  constructor() {
    this.#showNotificationEffect();
  }

  setReportBody(body: IReportBody): void {
    this.reportCharacterRequestBody.set(body);
  }

  /**
   * Уведомление об отправке отчета
   */
  #showNotificationEffect(): void {
    effect(() => {
      const isError = this.resource.error();
      const isLoading = this.resource.isLoading();

      if (!isLoading && !isError) {
        untracked(() => {
          try {
            const { id, report } = this.reportCharacterRequestBody() || {};
            if (!id || !report) {
              return;
            }

            this.reportCharacterRequestBody.set(null);
            this.#notificationsService.addSuccessNotification(this.#translocoService.translate('NOTIFICATIONS.CHAT_MESSAGE.REPORT_MESSAGE_SENT'));
          } catch (error) {
            this.#notificationsService.addErrorNotification(this.#translocoService.translate('NOTIFICATIONS.CHAT_MESSAGE.ERROR'));
          }
        });
      }
    });
  }
}
